const UUID_REGEX = /\b[a-f\d-]{36}\b/;

function isDynamicPathToken(pathToken: string, tenantName: string): boolean {
  if (UUID_REGEX.test(pathToken)) {
    return true;
  }

  if (tenantName.toLocaleLowerCase() === pathToken) {
    return true;
  }

  return false;
}

export function removeDynamicURLParts(tenantName: string): string {
  const pathTokens = window.location.pathname.split('/');
  const staticPathTokens = pathTokens.filter(
    (pathToken) => !isDynamicPathToken(pathToken, tenantName),
  );

  return staticPathTokens.join('/');
}
